import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Slide } from '../components/SlideComponents/slide.types';
import BackendService from '../services/backendService';
import { LessonAttachment } from '../services/backendService/backendService';
import { useMetrics } from './useMetrics';
import useRouterMatch from './useRouterMatch';

export const useTranslateSlides = () => {
  const { tenantId } = useRouterMatch();
  const metrics = useMetrics();
  const client = useQueryClient();
  const {
    mutate: translateSlides,
    isLoading,
    data,
    reset,
    isSuccess,
    error,
  } = useMutation(
    ({
      slides,
      lessonAttachments,
      originLanguage,
      outputLanguage,
    }: {
      slides: Slide[];
      lessonAttachments: LessonAttachment[];
      originLanguage: string;
      outputLanguage: string;
      onSuccessFunction?: (data: {
        slides: Slide[];
        lessonAttachments: LessonAttachment[];
      }) => void | undefined;
    }) => {
      metrics.logEvent('Translate.Slide', {
        originLanguage,
        outputLanguage,
        slideType: slides[0]?.type,
      });
      return BackendService.instance.template.translateSlides({
        slides,
        lessonAttachments,
        originLanguage,
        outputLanguage,
        activeTenantId: tenantId,
      });
    },
    {
      onSuccess: (data, { onSuccessFunction }) => {
        onSuccessFunction && onSuccessFunction(data);
      },
      onSettled: () => {
        client.invalidateQueries(['featureCredits', tenantId]);
      },
    },
  );
  return { translateSlides, isLoading, data, reset, isSuccess, error };
};
